export default "__VITE_ASSET__BHunO9MT__"